import React, { useEffect, useRef, useState } from 'react';
import TruckXs from 'src/Images/icons/truck/truck-xs.png';
import TruckSm from 'src/Images/icons/truck/truck-sm.png';
import TruckMd from 'src/Images/icons/truck/truck-md.png';
import TruckLg from 'src/Images/icons/truck/truck-lg.png';
import TruckXl from 'src/Images/icons/truck/truck-xl.png';
import { ReactComponent as SyncEventIcon } from 'src/Images/icons/common/SyncEvent.svg';
import BasicDetails from 'src/components/VehicleTrackingCreate/Outward/VehicleTrackingPlanning/BasicDetails';
import AttachDeliveryToVehicleTrackingPlanning from 'src/components/VehicleTrackingCreate/Outward/VehicleTrackingPlanning/AttachDeliveryToVehicleTrackingPlanning';
import AttachLoadToVehicleTrackingPlanning from 'src/components/VehicleTrackingCreate/Outward/VehicleTrackingPlanning/AttachLoadToVehicleTrackingPlanning';
import Breadcrumb from 'src/components/Breadcrumb';
import { useSetBreadcrumbData } from 'src/utils/SetBreadcrumbData';
import 'src/style/targetvsactualv2.css';
import { useDispatch, useSelector } from 'react-redux';
import TabCreateView from 'src/components/Layout/TabCreateView';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import {
  updateVehicleTrackingForOutward,
  getOutwardVehicleTrackingDetails,
  resetDeliveryForBusinessPartner,
  resetDeliveryListForVehicleNumber,
  resetOutwardVehicleTrackingDetails,
  createVehicleTrackingLoadHeader,
} from 'src/redux/Actions/VehicleTrackingOutward';
import { triggerManualSyncEventsFromSap } from 'src/redux/Actions/SyncLog';
import {
  getVehicleTrackingWorkflows,
  getPlants,
} from 'src/redux/Actions/VehicleTracking';
import { ReactComponent as Close } from 'src/Images/icons/common/close.svg';

const getDefaultDeliveryFilters = () => ({
  deliveryOrderSearchedTerm: null,
  businessPartnerSearchTerm: '',
  deliveryStartDate: new Date().toISOString().split('T')[0],
  deliveryEndDate: new Date().toISOString().split('T')[0],
});

function CreateVehicleTrackingPlanningForOutward() {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { vehicleTrackingNumber } = useParams();
  const authReducer = useSelector((state) => state.AuthReducer);
  const VehicleTrackingOutwardReducer = useSelector(
    (state) => state.VehicleTrackingOutwardReducer,
  );
  const vehicleTrackingDataReducer = useSelector(
    (state) => state.VehicleTrackingReducer,
  );

  const themeColor = authReducer?.userData?.tenant?.theme;
  const tenantOrganisationId = authReducer.userData.organisations?.id;
  const { outwardVehicleTrackingDetails } = VehicleTrackingOutwardReducer;

  const vehicleType =
    outwardVehicleTrackingDetails?.vehicleDetails?.vehicle_type;

  const breadcrumbTitle = `${
    outwardVehicleTrackingDetails?.vehicleDetails?.vehicle_number
  }`;

  const availableWorkflows = vehicleTrackingDataReducer.workflows;
  const { plantsData } = vehicleTrackingDataReducer;

  const plantDataOptions =
    plantsData?.map((plantObj) => ({
      value: plantObj.id,
      label: plantObj.name,
    })) || [];

  const [disableUpdateButton, setDisableUpdateButton] = useState(false);
  const [showUpdateConfirmation, setShowUpdateConfirmation] = useState(false);
  const [selectedDeliveryOrder, setSelectedDeliveryOrder] = useState([]);
  const [showSyncOptionsModal, setShowSyncOptionsModal] = useState(false);
  const [showCreateLoadForm, setShowCreateLoadForm] = useState(false);
  const [activePlanningTabId, setActivePlanningTabId] = useState(1);
  const [syncOptions, setSyncOptions] = useState({
    businessPartner: true,
    material: true,
    deliveryOrder: true,
  });
  const SyncTableKeyToTableNumberMapping = {
    businessPartner: '1',
    material: '2',
    deliveryOrder: '12', // backend options mapping
  };
  const tableNumbersToSync = Object.entries(syncOptions)
    .filter(([, value]) => value)
    .map(([key]) => SyncTableKeyToTableNumberMapping[key]);
  const [formData, setFormData] = useState({
    workflowId: null,
    plantId: null,
    showDeliveryComponent: true,
    autoLoadCreation: true,
    selectedVehicleOption: null,
    vehicleNumber: '',
  });

  const [errorField, setErrorField] = useState({
    workflowId: false,
    selectedDelivery: false,
  });

  const [selectedBusinessPartner, setSelectedBusinessPartner] = useState(null);
  const [loadLineItems, setLoadLineItems] = useState([]);
  const [isSubmittingLoad, setIsSubmittingLoad] = useState(false);
  const attachedDeliveryHeaderIdsRef = useRef(new Set());
  const prefillDeliveryIdsRef = useRef(null);
  const deliveryListToPrefillForVehicleNumber =
    VehicleTrackingOutwardReducer?.deliveryDropdownOptions?.delivery;
  const [deliveryFilters, setDeliveryFilters] = useState(
    getDefaultDeliveryFilters(),
  );

  const workflowDataOption =
    availableWorkflows?.map((availableWorkflow) => ({
      value: availableWorkflow.id,
      label: availableWorkflow.name,
    })) || [];

  useEffect(() => {
    dispatch(
      getOutwardVehicleTrackingDetails(
        vehicleTrackingNumber,
        tenantOrganisationId,
      ),
    );
    dispatch(getVehicleTrackingWorkflows(tenantOrganisationId, '2')); // hardcoded to outward
    dispatch(getPlants(tenantOrganisationId));
  }, [dispatch, tenantOrganisationId, vehicleTrackingNumber]);

  useEffect(() => {
    if (outwardVehicleTrackingDetails?.vehicleDetails?.vehicle_number) {
      setFormData((prev) => ({
        ...prev,
        selectedVehicleOption: {
          value: outwardVehicleTrackingDetails?.vehicleDetails?.vehicle_id,
          label: outwardVehicleTrackingDetails?.vehicleDetails?.vehicle_number,
        },
        vehicleNumber:
          outwardVehicleTrackingDetails?.vehicleDetails?.vehicle_number,
      }));
    }
  }, [outwardVehicleTrackingDetails]);

  useEffect(() => {
    if (formData?.autoLoadCreation) {
      setShowCreateLoadForm(false);
    }
  }, [formData?.autoLoadCreation]);

  function handleOnChange(e) {
    const { name, type, checked, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  }

  function handleSyncOptionChange(e) {
    const { name, checked } = e.target;
    setSyncOptions((prev) => ({
      ...prev,
      [name]: checked,
    }));
  }

  function handleConfirmSync() {
    dispatch(
      triggerManualSyncEventsFromSap(tenantOrganisationId, tableNumbersToSync),
    );
    setShowSyncOptionsModal(false);
  }

  function validateUpdateOutward() {
    const workflowError = formData.workflowId == null;
    // const deliveryError = selectedDeliveryOrder.length === 0;

    if (workflowError) {
      setErrorField({
        workflowId: workflowError,
      });

      return false;
    }

    setErrorField({
      workflowId: false,
      selectedDelivery: false,
    });

    return true;
  }

  function handleOpenUpdateConfirmation() {
    if (disableUpdateButton) return;
    if (!validateUpdateOutward()) return;

    setShowUpdateConfirmation(true);
  }

  function handleUpdateOutward() {
    if (disableUpdateButton) return;
    if (!validateUpdateOutward()) {
      setShowUpdateConfirmation(false);
      return;
    }

    setShowUpdateConfirmation(false);
    setDisableUpdateButton(true);

    const updateData = {
      tenant_organisation_id: tenantOrganisationId,
      vehicle_tracking_number: vehicleTrackingNumber,
      workflow_id: formData.workflowId,
      plant_id: formData.plantId || null,
      is_auto_load_creation_enabled: formData?.autoLoadCreation ?? true,
      delivery_header_id: selectedDeliveryOrder?.map(
        (deliveryObj) => deliveryObj?.delivery_id,
      ),
    };

    dispatch(updateVehicleTrackingForOutward(updateData))
      .then(() => {
        navigate('/outward/planning/');
      })
      .finally(() => {
        setDisableUpdateButton(false);
      });
  }

  const buildLoadPayload = () => {
    const deliveryHeaderIdsToAttach = [];
    const loadLineItemsPayload = [];
    loadLineItems.forEach((deliveryObj) => {
      const deliveryId = deliveryObj?.delivery_id;
      if (deliveryId && !attachedDeliveryHeaderIdsRef.current.has(deliveryId)) {
        deliveryHeaderIdsToAttach.push(deliveryId);
      }

      (deliveryObj?.line_items || [])
        .filter((item) => item?.delivery_line_item_id)
        .forEach((item) => {
          const payloadLineItem = {
            delivery_line_item_id: item.delivery_line_item_id,
            receiving_quantity: item.quantity,
            product_id: item.product?.product_id ?? null,
            business_partner_id: deliveryObj?.ship_to_party?.id ?? null,
            pack_quantity: deliveryObj?.pack_quantity ?? null,
          };

          if (
            deliveryObj?.pack_type &&
            typeof deliveryObj.pack_type === 'object'
          ) {
            payloadLineItem.pack_type_id = deliveryObj.pack_type.value;
          }

          loadLineItemsPayload.push(payloadLineItem);
        });
    });

    return {
      delivery: deliveryHeaderIdsToAttach,
      load_line_items: loadLineItemsPayload,
    };
  };

  function handleCreateLoad() {
    if (isSubmittingLoad || !loadLineItems.length) return;

    setIsSubmittingLoad(true);

    const { delivery, load_line_items: loadLineItemsPayload } =
      buildLoadPayload();

    const payload = {
      tenant_organisation_id: tenantOrganisationId,
      vehicle_tracking_number: vehicleTrackingNumber,
      delivery,
      load_line_items: loadLineItemsPayload,
    };

    dispatch(createVehicleTrackingLoadHeader(payload))
      .then(() => {
        delivery.forEach((deliveryId) =>
          attachedDeliveryHeaderIdsRef.current.add(deliveryId),
        );
        setLoadLineItems([]);
        setShowCreateLoadForm(false);
        navigate('/outward/planning/');
      })
      .finally(() => {
        setIsSubmittingLoad(false);
      });
  }

  const isCreateLoadActionActive =
    formData?.autoLoadCreation === false &&
    activePlanningTabId === 3 &&
    showCreateLoadForm;

  function handleFooterButtonClick() {
    if (isCreateLoadActionActive) {
      handleCreateLoad();
      return;
    }
    handleOpenUpdateConfirmation();
  }

  const isFooterButtonBusy = disableUpdateButton || isSubmittingLoad;
  const isUpdateButtonDisabled =
    isFooterButtonBusy ||
    (isCreateLoadActionActive && !(loadLineItems || []).length);
  const footerButtonLabel = isSubmittingLoad
    ? 'Creating Load...'
    : disableUpdateButton
      ? 'Updating...'
      : isCreateLoadActionActive
        ? 'Create Load'
        : 'Update Vehicle Tracking';

  const handleDeleteDeliveryOrder = (deliveryId) => {
    setSelectedDeliveryOrder((prev) =>
      prev.filter((item) => item.delivery_id !== deliveryId),
    );
    setLoadLineItems((prev) =>
      prev.filter((item) => item.delivery_id !== deliveryId),
    );
  };

  const createVehiclePlanningComponents = [
    {
      id: 1,
      title: 'Basic Details',
      component: (
        <BasicDetails
          formData={formData}
          handleOnChange={(e) => handleOnChange(e)}
          errorField={errorField}
          outwardVehicleTrackingDetails={outwardVehicleTrackingDetails}
          workflowDataOption={workflowDataOption}
          plantDataOptions={plantDataOptions}
        />
      ),
      indicator: errorField?.workflowId,
    },
    {
      id: 2,
      title: 'Attach Delivery',
      component: (
        <AttachDeliveryToVehicleTrackingPlanning
          formData={formData}
          selectedDeliveryOrder={selectedDeliveryOrder}
          setSelectedDeliveryOrder={setSelectedDeliveryOrder}
          handleOnChange={(e) => handleOnChange(e)}
          errorField={errorField}
          handleDeleteDeliveryOrder={handleDeleteDeliveryOrder}
          selectedBusinessPartner={selectedBusinessPartner}
          setSelectedBusinessPartner={setSelectedBusinessPartner}
          deliveryFilters={deliveryFilters}
          setDeliveryFilters={setDeliveryFilters}
        />
      ),
      indicator: errorField?.selectedDelivery,
    },
  ];

  if (formData?.autoLoadCreation === false) {
    createVehiclePlanningComponents.push({
      id: 3,
      title: 'Attach Load',
      component: (
        <AttachLoadToVehicleTrackingPlanning
          formData={formData}
          selectedDeliveryOrder={selectedDeliveryOrder}
          showCreateLoadForm={showCreateLoadForm}
          setShowCreateLoadForm={setShowCreateLoadForm}
          loadLineItems={loadLineItems}
          setLoadLineItems={setLoadLineItems}
        />
      ),
    });
  }

  useEffect(() => {
    if (!Array.isArray(deliveryListToPrefillForVehicleNumber)) return;

    const deliveryIds = deliveryListToPrefillForVehicleNumber
      .map((deliveryObj) => deliveryObj?.delivery_id)
      .join('|');

    if (prefillDeliveryIdsRef.current === deliveryIds) return;

    prefillDeliveryIdsRef.current = deliveryIds;

    setSelectedDeliveryOrder(deliveryListToPrefillForVehicleNumber);

    setLoadLineItems((prev) => {
      const latestDeliveryIds = new Set(
        deliveryListToPrefillForVehicleNumber.map(
          (deliveryObj) => deliveryObj.delivery_id,
        ),
      );

      return prev.filter((deliveryObj) =>
        latestDeliveryIds.has(deliveryObj.delivery_id),
      );
    });
  }, [deliveryListToPrefillForVehicleNumber]);

  // Prefill workflow if already exists
  useEffect(() => {
    const workflowId =
      outwardVehicleTrackingDetails?.vehicleDetails?.workflow?.id;
    if (workflowId && !formData.workflowId) {
      handleOnChange({
        target: {
          name: 'workflowId',
          value: workflowId,
        },
      });
    }
    const plantId = outwardVehicleTrackingDetails?.vehicleDetails?.plant_id;
    if (plantId && !formData.plantId) {
      handleOnChange({
        target: {
          name: 'plantId',
          value: plantId,
        },
      });
    }
  }, [outwardVehicleTrackingDetails]);

  function handleCancel() {
    navigate('/outward/planning/');
  }

  useSetBreadcrumbData(location.pathname, breadcrumbTitle);

  useEffect(
    () => () => {
      setSelectedDeliveryOrder([]);
      dispatch(resetDeliveryForBusinessPartner());
      dispatch(resetDeliveryListForVehicleNumber());
      dispatch(resetOutwardVehicleTrackingDetails());
    },
    [],
  );

  return (
    <div className="page-layout div-flex-column">
      <div className="div-flex-column">
        <div className="header-vehicle-tracking-detail-page-padding border-bottom">
          <div className="div-flex-row cg-5">
            <Breadcrumb />
          </div>

          <div className="div-space-between header-content-vehicle-tracking-detail-page-padding">
            <div className="div-flex-row cg-10 div-align-center">
              <div className="div-align-center">
                {vehicleType === '1' ? (
                  <img
                    src={TruckXs}
                    alt="truck"
                    className="vehicle-tracking-detail-page-icon-size-truck"
                  />
                ) : vehicleType === '2' ? (
                  <img
                    src={TruckSm}
                    alt="truck"
                    className="vehicle-tracking-detail-page-icon-size-truck"
                  />
                ) : vehicleType === '3' ? (
                  <img
                    src={TruckMd}
                    alt="truck"
                    className="vehicle-tracking-detail-page-icon-size-truck"
                  />
                ) : vehicleType === '4' ? (
                  <img
                    src={TruckLg}
                    alt="truck"
                    className="vehicle-tracking-detail-page-icon-size-truck"
                  />
                ) : (
                  <img
                    src={TruckXl}
                    alt="truck"
                    className="vehicle-tracking-detail-page-icon-size-truck"
                  />
                )}
              </div>

              <div className="div-align-center">
                <div className="div-align-center text-xxxl text-bold">
                  {
                    outwardVehicleTrackingDetails?.vehicleDetails
                      ?.vehicle_number
                  }
                </div>
              </div>
            </div>
            <div
              className="div-align-center"
              onClick={() => setShowSyncOptionsModal(true)}
              role="button"
              tabIndex={0}
              aria-label="Sync Vehicle Tracking Data"
            >
              <SyncEventIcon className="icon-size-xl" />
            </div>
          </div>
        </div>
        <div
          className={` div-flex-column form-tab-container div-space-between`}
        >
          <TabCreateView
            createLeadFormComponents={createVehiclePlanningComponents}
            onTabChange={setActivePlanningTabId}
          />

          <div className="div-space-between footer-content-for-page">
            <button
              className={`common-btn-outlined theme-border-color-${themeColor}`}
              onClick={handleCancel}
            >
              Cancel
            </button>
            <div className="div-flex-row cg-20">
              <button
                data-testid="update-vehicle-tracking-btn"
                className={`common-btn theme-background-${themeColor}`}
                type="button"
                onClick={handleFooterButtonClick}
                disabled={isUpdateButtonDisabled}
              >
                {footerButtonLabel}
              </button>
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={showUpdateConfirmation}
        onHide={() => setShowUpdateConfirmation(false)}
        centered
      >
        <Modal.Body>
          <div className="d-flex flex-column rg-10">
            <div className="text-lg text-center text-semi-bold">
              Confirm Vehicle Tracking Update
            </div>
            <div className="text-sm text-center text-grey">
              Are you sure you want to update this vehicle tracking plan?
            </div>
            <div className="div-flex-row div-space-between mt-3">
              <button
                className={`vehicle-tracking-detail-add-vehcile-data-btn theme-text-${themeColor} theme-border-color-${themeColor} div-align-center`}
                onClick={() => setShowUpdateConfirmation(false)}
                disabled={disableUpdateButton}
              >
                <span className="text-md">Cancel</span>
              </button>
              <button
                className={`vehicle-tracking-detail-move-stage-btn div-align-center theme-background-${themeColor}`}
                onClick={handleUpdateOutward}
                disabled={disableUpdateButton}
              >
                <span className="text-md">
                  {disableUpdateButton ? 'Updating...' : 'Confirm'}
                </span>
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={showSyncOptionsModal}
        onHide={() => setShowSyncOptionsModal(false)}
        centered
        dialogClassName="sync-item-modal"
        contentClassName="sync-item-modal-content"
      >
        <Modal.Body>
          <button
            type="button"
            className="sync-modal-close"
            onClick={() => setShowSyncOptionsModal(false)}
            aria-label="Close"
          >
            <Close className="icon-size-md" color="grey" />
          </button>
          <div className="div-flex-column rg-20">
            <div className="sync-modal-icon">
              <SyncEventIcon className="icon-size-xxxl" />
            </div>
            <div className="div-flex-column">
              <div className="text-xxl text-semi-bold">Sync Item</div>

              <div className="text-md text-grey">
                Select the below items you want to sync.
              </div>
            </div>

            <div className="sync-modal-divider" />

            <div className="div-flex-column rg-20">
              <label className="div-flex-row align-items-center cg-10 text-md text-400">
                <input
                  type="checkbox"
                  name="businessPartner"
                  className="sync-modal-checkbox-row-input"
                  checked={syncOptions.businessPartner}
                  onChange={handleSyncOptionChange}
                />
                <span>Sync Business Partner</span>
              </label>

              <label className="div-flex-row align-items-center cg-10 text-md text-400">
                <input
                  type="checkbox"
                  name="material"
                  className="sync-modal-checkbox-row-input"
                  checked={syncOptions.material}
                  onChange={handleSyncOptionChange}
                />
                <span>Sync Product</span>
              </label>

              <label className="div-flex-row align-items-center cg-10 text-md text-400">
                <input
                  type="checkbox"
                  name="deliveryOrder"
                  className="sync-modal-checkbox-row-input"
                  checked={syncOptions.deliveryOrder}
                  onChange={handleSyncOptionChange}
                />
                <span>Sync Delivery Order</span>
              </label>
            </div>
            <div className="div-flex-column rg-10 div-align-center">
              <button
                type="button"
                className={`sync-modal-submit theme-background-${themeColor}`}
                onClick={handleConfirmSync}
                disabled={!Object.values(syncOptions).some(Boolean)}
              >
                <span className="text-md">Sync Now</span>
              </button>

              <button
                type="button"
                className="sync-modal-cancel"
                onClick={() => setShowSyncOptionsModal(false)}
              >
                <span className="text-md">Cancel</span>
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default CreateVehicleTrackingPlanningForOutward;
